import * as Sentry from '@sentry/react'

// Error reporting (#12). Rails renders the sentry-* meta tags only when SENTRY_DSN is set, so
// development and test send nothing. Errors only: no tracing or replay. Events carry the User id
// and Workspace slug, never the email, and the URL loses its query string (auth link tokens).
function meta(name: string): string | undefined {
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content || undefined
}

const dsn = meta('sentry-dsn')

if (dsn) {
  Sentry.init({
    dsn,
    environment: meta('sentry-environment'),
    release: meta('sentry-release'),
    initialScope: { tags: { platform: 'react' } },
    beforeSend(event) {
      if (event.request?.url) event.request.url = event.request.url.split('?')[0]
      if (event.request) delete event.request.query_string
      return event
    },
  })
}

export function setSentryContext(userId: number | undefined, workspaceSlug: string) {
  Sentry.setUser(userId === undefined ? null : { id: String(userId) })
  Sentry.setTag('workspace_slug', workspaceSlug)
}

export function captureRouteError(error: unknown) {
  Sentry.captureException(error)
}
